import { render, staticRenderFns } from "./PaymentBatchListItem.vue?vue&type=template&id=6663b336"
import script from "./PaymentBatchListItem.vue?vue&type=script&lang=js"
export * from "./PaymentBatchListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports